import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'charCounter',
})
export class CharCounterPipe implements PipeTransform {
  transform(value: string | undefined, maxLen: number): string {
    return `${value?.length || 0}/${maxLen}`;
  }
}
